import Tippy from '@tippyjs/react';

import wordpressData from 'data';

/**
 * Matches special attributes names in src/wp-content/themes/symmons/src/Symmons/Salsify/Prop_ID.php
 */
const PRODUCT_ICON_LABELS: { name: string; label: string; file: string }[] = [
  { name: 'California Compliant', label: 'California Compliant', file: 'label-cg.svg' },
  { name: 'WaterSense Certified', label: 'WaterSense Certified', file: 'label-watersense.svg' },
  { name: 'The Buy American Act', label: 'Build America, Buy America Act', file: 'label-american.svg' },
  { name: 'ADA Compliant', label: 'ADA Compliant', file: 'label-ada.svg' },
];

export function ProductIconLabels({ names, layout = 'card' }: { names: string[]; layout?: 'card' | 'hero' }) {
  if (!names.length) {
    return null;
  }

  const icons = PRODUCT_ICON_LABELS.filter((row) => names.includes(row.name));
  if (!icons.length) {
    return null;
  }

  const base = `${wordpressData.themeAssetsUrl}/images/icon/`;

  if (layout === 'hero') {
    return (
      <li className="u-ml-auto">
        <p className="c-product-icon-label">
          {icons.flatMap((row, idx) => [
            idx ? ' ' : null,
            <Tippy key={row.name} content={row.label}>
              <span className="c-tooltip">
                <img src={`${base}${row.file}`} alt={row.label} />
              </span>
            </Tippy>,
          ])}
        </p>
      </li>
    );
  }

  return (
    <div className="c-card__icon-labels">
      {icons.flatMap((row, idx) => [
        idx ? ' ' : null,
        <span key={row.name} className="c-tooltip">
          <img src={`${base}${row.file}`} alt={row.label} />
        </span>,
      ])}
    </div>
  );
}
